import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import {
  HttpService,
  API,
  swal,
  Title,
  toast,
  Messages,
  // DateFormat,
  Spinner
  // ExportToExcel
} from '../../../config/react'
import DataTable from 'react-data-table-component'

const ProductSize = () => {
  const [SizeList, setSizeList] = useState([])
  const [isForceUpdate, setForceUpdate] = useState(false)
  const [IsAuth, setIsAuth] = useState(false)
  const [loading, setLoading] = useState(true)

  const columns = [
    // {
    //   name: 'Size',
    //   sortable: true,
    //   sortField: 'size',
    //   selector: (row) => row.size
    // },
    {
      name: 'Type',
      sortField: 'Type',
      selector: (row) => row.type
    },
    {
      name: 'Country',
      selector: (row) => row.country
    },
    // {
    //   name: 'Created Date',
    //   sortable: true,
    //   sortField: 'created_at',
    //   selector: (row) => <DateFormat value={row.created_at}></DateFormat>
    // },
    {
      name: 'Status',
      selector: (row) => (row.status === 1 ? <label>Active</label> : <label>Inactive</label>)
    },
    {
      name: 'Action',
      selector: (row) => (
        <div className="action-btn">
          <Link
            to={'/system/productsize/edit/' + row.type + '?country=' + row.country_id}
            className="text-dark"
            title="Edit"
          >
            <i
              className="fa fa-pencil-square-o"
              aria-hidden="true"
            ></i>{' '}
          </Link>
          <Link
            onClick={(e) => {
              if (row.is_product_exist) {
                e.preventDefault()
              } else {
                DeleteProductSize(e, row.type)
              }
            }}
            to=""
            className={row.is_product_exist ? 'text-dark disabled' : 'text-dark'}
            title={row.is_product_exist ? Messages.ProductSizeDeleteError : 'Delete'}
            disabled={row.is_product_exist}
          >
            <i
              className="fa fa-trash-o"
              aria-hidden="true"
            ></i>{' '}
          </Link>
        </div>
      )
    }
  ]

  const DefaultFilters = {
    page: 1,
    search: '',
    page_size: 10,
    sort_column: '',
    sort_direction: ''
  }
  const [CustomFilters, setCustomFilters] = useState(DefaultFilters)
  const [totalRows, settotalRows] = useState()

  useEffect(() => {
    setIsAuth(true)
    document.title = Title.ProductSize
    // GetProductSizeList()
    GetProductSizeCategoryList()
  }, [CustomFilters])

  // const GetProductSizeList = () => {
  //   const passData = {
  //     page: CustomFilters.page,
  //     search: CustomFilters.search,
  //     page_size: CustomFilters.page_size,
  //     sort_column: CustomFilters.sort_column,
  //     sort_direction: CustomFilters.sort_direction
  //   }

  //   setLoading(true)
  //   HttpService.postApi(API.GetProductSizeAdminList, passData).then((response) => {
  //     setLoading(false)
  //     if (response.data.status === true) {
  //       const data = response.data.result[1]
  //       // var data = response.data.result[0];
  //       console.log(data)
  //       // setSizeList(data)
  //       settotalRows(data)
  //       setForceUpdate(!isForceUpdate)
  //     }
  //   })
  // }
  const GetProductSizeCategoryList = () => {
    HttpService.postApi(API.GetProductSizeCategoryList).then((response) => {
      setLoading(false)
      if (response.data.status === true) {
        const data = response.data.result[0]
        setSizeList(data)
        settotalRows(data.length)
        setForceUpdate(!isForceUpdate)
      }
    })
  }
  const handlePageChange = (e) => {
    setCustomFilters({ ...CustomFilters, page: e })
  }

  const handlePerRowsChange = (e) => {
    setCustomFilters({ ...CustomFilters, page: 1, page_size: e })
  }

  const subHeaderComponentMemo = React.useMemo(() => {
    return (
      <input
        type="text"
        title="Search For Size, Category Name, Country."
        className="form-control col-md-3"
        placeholder="Search"
        onChange={(e) => setCustomFilters({ ...CustomFilters, search: e.target.value })}
      />
    )
  })

  const DeleteProductSize = async (e, type) => {
    e.preventDefault()
    swal(Messages.SwalDeleteProp).then(function (isConfirm) {
      if (isConfirm) {
        const param = {
          _type: type
        }
        setLoading(true)
        HttpService.postApi(API.DeleteProductSize, param).then((response) => {
          setLoading(false)

          toast.success(Messages.RecordDeleted)
          // GetProductSizeList()
          GetProductSizeCategoryList()
          setForceUpdate(!isForceUpdate)
        })
      }
    })
  }

  const handleSort = (e, direction) => {
    setCustomFilters({
      ...CustomFilters,
      sort_column: e.sortField,
      sort_direction: direction
    })
  }
  // const handleExportExcel = () => {
  //   HttpService.postApi(API.GetProductSizeExcel).then((response) => {
  //     if (response.data.result) {
  //       ExportToExcel(response.data.result[0], 'ProductSize')
  //     }
  //   })
  // }

  return !IsAuth ? (
    <Spinner />
  ) : (
    <div className="content-wrapper pb-0">
      <div className="page-header">
        <h3 className="page-title"> {Title.ProductSize} </h3>
        <div className="btn-group">
          <Link
            to="/system/productsize/add"
            className="btn btn-dark btn-fw rounded mr-2"
          >
            {' '}
            {Title.AddProductSize}{' '}
          </Link>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              {/* <button
                className="btn btn-primary float-right m-1"
                onClick={handleExportExcel}
              >
                Export Excel
              </button> */}
              <div className="table-responsive">
                <DataTable
                  columns={columns}
                  data={SizeList}
                  // progressPending={loading}
                  pagination
                  // paginationServer
                  persistTableHead={true}
                  paginationTotalRows={totalRows}
                  onChangeRowsPerPage={handlePerRowsChange}
                  onChangePage={handlePageChange}
                  subHeader
                  subHeaderComponent={subHeaderComponentMemo}
                  onSort={handleSort}
                  sortServer
                  progressPending={loading}
                  progressComponent={<Spinner />}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ProductSize
